import { configureStore } from "@reduxjs/toolkit";
import coursesReducer, { initialState as coursesInitial } from "./slices/coursesSlice";

// --- Booking-state persistence (B-fix) --------------------------------------
// The booking flow is multi-step but previously held ALL progress in memory only,
// so a refresh / browser-back / returning to a backgrounded tab wiped the cart and
// dumped the customer back to step 1 (a top abandonment driver). Persist only the
// booking whitelist to sessionStorage — NOT the transient search results and NEVER
// any card data — and rehydrate on load. sessionStorage clears when the tab closes.
const PERSIST_KEY = "stg_booking_state_v1";
const PERSIST_FIELDS = [
  "bookingType",
  "learners",
  "billingData",
  "selectedCourse",
  "selectedCourseId",
];

function loadPreloadedState() {
  try {
    const raw = window.sessionStorage.getItem(PERSIST_KEY);
    if (!raw) return undefined;
    const saved = JSON.parse(raw);
    if (!saved || typeof saved !== "object") return undefined;
    const slim = {};
    PERSIST_FIELDS.forEach((k) => {
      if (saved[k] !== undefined) slim[k] = saved[k];
    });
    // Merge over a full initialState so non-persisted slice fields stay valid.
    return { courses: { ...coursesInitial, ...slim } };
  } catch (e) {
    return undefined;
  }
}

function saveState(state) {
  try {
    const c = (state && state.courses) || {};
    const slim = {};
    PERSIST_FIELDS.forEach((k) => {
      if (c[k] !== undefined) slim[k] = c[k];
    });
    window.sessionStorage.setItem(PERSIST_KEY, JSON.stringify(slim));
  } catch (e) {
    /* ignore quota / serialisation errors */
  }
}

export const store = configureStore({
  reducer: {
    courses: coursesReducer,
  },
  preloadedState: loadPreloadedState(),
});

// Throttle persistence writes (~400ms) to avoid thrashing sessionStorage on keystrokes.
let _persistTimer = null;
store.subscribe(() => {
  if (_persistTimer) return;
  _persistTimer = setTimeout(() => {
    _persistTimer = null;
    saveState(store.getState());
  }, 400);
});
